export const ConditionalRendering = ({ isTrue, children }) => {
  if (isTrue) {
    return children;
  } else return null;
};
